<template>
  <div>
    <header-component></header-component>

    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">
            Vendor's Labors
          </h3>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="labors"
        >
          <el-table-column label="Service Request No.">
            <template slot-scope="scope"
              >{{ scope.row.service_request.service_request_number }}
            </template>
          </el-table-column>

          <el-table-column label="Total Amount" prop="total_amount">
            <template slot-scope="scope">
              <i class="fas fa-rupee-sign" />
              {{ scope.row.total_amount }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      labors: []
    };
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "header-component": headerComponent
  },
  mounted() {
    if (this.$route.params.vendorId) {
      this.getLabors(this.$route.params.vendorId);
    }
  },
  methods: {
    ...mapActions({
      getVendorLabors: "vendor/getVendorLabors"
    }),

    getLabors(vendorId) {
      this.getVendorLabors(vendorId)
        .then(res => {
          this.labors = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
